import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetTechnicianQuery } from '../../../api/queries/technician';
import Card from '../../../components/Card/Card';
import { MapPin } from '../../../components/CustomIcons/MapPin';
import styles from './ExpertCard.module.scss';

export interface ExpertCardProps {
  ticketId: string;
}

const ExpertCard: FC<ExpertCardProps> = ({ ticketId }) => {
  const { t } = useTranslation();
  const { technician: expert } = useGetTechnicianQuery(ticketId);

  if (!expert) return null;
  const profileImage = expert.profileImage || '/assets/guido.png';

  return (
    <Card className={styles.cardContainer}>
      <div className={styles.expertId}>
        <div className={styles.expertImage}>
          <img alt={t('expertCardAlts:expertPhotograph')} src={profileImage} />
        </div>
        <div className={styles.expertInfo}>
          <span className={styles.expertName}>{expert.name}</span>
          {!!expert.city && (
            <div className={styles.expertLocation}>
              <MapPin className={styles.locationIcon} />
              <span className={styles.expertCity}>{expert.city}</span>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default ExpertCard;
